// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-page[data-v-616dd22e]{-webkit-box-sizing:border-box;box-sizing:border-box;padding:30px;background:#fff;height:calc(100vh - 104px)}.error-page-title[data-v-616dd22e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:50px;font-weight:600}.error-page-title i[data-v-616dd22e]{font-size:24px;color:#c31422;margin-right:15px}.error-page-title span[data-v-616dd22e]{color:#2b2d42;font-size:22px}", ""]);
// Exports
module.exports = exports;
